"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpKeywordNavIndicator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var KeywordNavIndicator_styles_1 = require("./KeywordNavIndicator.styles");
var DpPadItem = ((0, jsx_runtime_1.jsx)("div", { style: KeywordNavIndicator_styles_1.padItemStyle, className: "dp-pad-item d-inline-block px-2 py-2 m-1 bg-white text-dark", children: "-" }));
var DpKeywordNavIndicator = function () { return ((0, jsx_runtime_1.jsxs)("div", { className: "text-center", children: [(0, jsx_runtime_1.jsx)("div", { children: DpPadItem }), (0, jsx_runtime_1.jsxs)("div", { children: [DpPadItem, DpPadItem, DpPadItem] })] })); };
exports.DpKeywordNavIndicator = DpKeywordNavIndicator;
exports.default = exports.DpKeywordNavIndicator;
